<template>
  <div class="similar-venue-block">
      <div class="title">
        <div class="title__content">
        <h3>{{ isNCH ? strings.youCanAlsoBook : strings.similarvenues}}</h3>
        <p class="small" v-if="venue_arr.length > 0 && !isNCH">{{ strings.somesimilarvenues }}.</p>
        </div>
        <div class="title__action" v-if="venue_arr.length > 3">
            <a href="" class="button" @click.stop.prevent="prev()">←</a>
            <a href="" class="button" @click.stop.prevent="next()">→</a>
        </div>
    </div>
    <div class="venue-grid__cta button full-on-mobile swipemore" v-if="venue_arr.length > 1">{{ strings.swipemore }}</div>

    <slick ref="slick" :options="slickOptions" class="venue-grid" id="plz">
        <li class="venue-grid__item" v-for="(venue,key) in venue_arr" :key="key">
            <a :href="venue.link" class="venue-grid__link">
                <div class="venue-grid__img" :style="venue.image.replace('http://web-legacy.s3.eu-central-1.amazonaws.com/drupal-root/s3fs-public','https://assets-mp.meetingpackage.com/public')">
                <span v-if="!isNCH" class="venue-grid__price">{{ venue.price }} {{ venue.currency }}/h</span>
                </div>
                <div class="venue-grid__content">
                <h3 class="venue-grid__title">{{ venue.title }}</h3>
                <p class="venue-grid__meta">{{ venue.distance }} {{ strings.fromthisvenue }}</p>
                </div>
            </a>
        </li>
    </slick>
    <div class="temp mb-15 radio__no-avail" v-if="venue_arr.length == 0">
        <label for="radio6">
            <div class="radio__main">
                <div class="radio__head radio__head-no-avail">
                    <h3>{{ strings.novenuenearby }}.</h3>
                </div>
            </div>
        </label>
    </div>

  </div>
</template>
    
<script>
import Slick from 'vue-slick';
import Vue from 'vue';
import '../../node_modules/slick-carousel/slick/slick.scss';
import '../../node_modules/slick-carousel/slick/slick-theme.scss';
import * as hf from '../assets/misc/helperFunctions.js'

export default {
  components: {
        Slick,
    },
    props: ['strings', 'venueInfo'],
    data() {
        return {
            slickOptions: {
                slidesToShow: 3,
                infinite: true,
                accessibility: true,
                adaptiveHeight: false,
                arrows: true,
                draggable: true,
                edgeFriction: 0.30,
                swipe: true,
                responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 960,
                    settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 650,
                    settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                    }
                }
                ]
            },
            venue_arr: [],
        }
    },
    computed: {
        isNCH() {
            return this.$store.state.isNCH;
        },
        selectedLang () {
            return this.$store.state.selectedLang;
        },
    },
    methods: {
        next() {
            this.$refs.slick.next();
        },

        prev() {
            this.$refs.slick.prev();
        },
        nearbyVenues() {
            if(this.$store.state.venueInfo.nearby_venues.length > 0){
                let nearby_arr = this.$store.state.venueInfo.nearby_venues;
                this.venue_arr = nearby_arr;
                if(nearby_arr.length == 1) {
                    this.slickOptions = [];
                    this.slickOptions.slidesToShow = 1;
                }

                if (nearby_arr.length == 2) {
                    this.slickOptions = [];
                    this.slickOptions.slidesToShow = 2;
                }
                // Re-slick.
                this.$refs.slick.destroy();
                let vm = this;
                Vue.nextTick().then(this.$refs.slick.create);
            }
        }
    },
    watch: {
        venueInfo: function(value) {
            this.nearbyVenues();
        }
    }
}
</script>

<style scoped>
    .swipemore {
        background-color: white !important;
        color: black !important;
    }
</style>
